/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CloudResourceConfigurationInventoryBackup {
  /**
  * Whether inventory is enabled. Only present when systemControlled is false (user-controlled). When systemControlled is true (auto mode), this field is null as the decision is made at runtime based on bucket size.
  */
  'enabled'?: boolean;
  /**
  * Whether inventory is system-controlled (auto mode) or user-controlled (force-true/force-false)
  */
  'systemControlled': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "enabled",
      "baseName": "enabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "systemControlled",
      "baseName": "systemControlled",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CloudResourceConfigurationInventoryBackup.attributeTypeMap;
  }

  public constructor() {
  }
}

